"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const route_utils_js_1 = require("../../vanilla/route-utils.js");
const vanillaOidc_js_1 = require("../../vanilla/vanillaOidc.js");
const SilentLogin = ({ configurationName }) => {
    const queryParams = (0, route_utils_js_1.getParseQueryStringFromLocation)(window.location.href);
    const getOidc = vanillaOidc_js_1.VanillaOidc.get;
    const oidc = getOidc(configurationName);
    let extras = null;
    for (const [key, value] of Object.entries(queryParams)) {
        if (key === 'state' || key === 'scope') {
            continue;
        }
        if (extras === null) {
            extras = {};
        }
        extras[key] = value;
    }
    (0, react_1.useEffect)(() => {
        if (!oidc.tokens) {
            oidc.loginAsync(null, extras, true, queryParams.scope);
        }
    }, []);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
};
exports.default = SilentLogin;
//# sourceMappingURL=SilentLogin.component.js.map